export default __webpack_public_path__ + "static/media/magicsnacks@2x.1f15b4c5.jpg";